// extracted by mini-css-extract-plugin
module.exports = {"link":"logo-module--link--10byk","logo":"logo-module--logo--2cGtS"};